import { useEffect, useState } from 'react';
import ConsoleTemplate from '../_shoru_shared_library/template/ConsoleTemplate';
import AppBar from '../components/AppBar';
import consoleRouter from './consoleRouter';

function Console() {
  
  return (

    <ConsoleTemplate 
      appBar={<AppBar />}
      router={consoleRouter} 
      accentColour='#0984e3'
      appName='castingbot'
      consoleName='console'
      season_restricted
    />

  )

}

export default Console;